import Vue from 'vue'
import router from './router'
import App from './App.vue'
import filter from './filter'
import api from './constant/api'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

Vue.use(ElementUI);

let getImage = path => require('./assets/image/' + path);//获取图片路径ES6写法

Vue.prototype.confirmBox = async (msg,cb) =>{//确定提示框
    try{
        await Vue.prototype.$confirm(msg,'提示',{confirmButtonText: '确定',cancelButtonText: '取消',type: 'warning'});
        cb();
    }catch (e){
        console.log(e);
    }
}

Vue.prototype.getImage = getImage;//绑定到原型链中,固定路径加载静态图片

Vue.prototype.api = api;

Vue.prototype.baseURL = window.config.baseURL;

Vue.prototype.uploadUrl = window.config.uploadUrl;

Array.prototype.getIndexById = function(id){//从数组中删除某值By Id
    for(let i=0; i<this.length; i++) {
        if(this[i].id == id) {
            return i;
        }
    }
    return -1;
}

for(let p in filter){//遍历对象属性，加载所有方法到filter
    Vue.filter( p ,filter[p]);
}

let vm = new Vue({
    el: '#app',
    router,
    render: h => h(App)
})

export default vm//导出这个实
